import { IMenuItem } from '../interfaces/MenuItem.interface';
import { MenuItem } from '../models/MenuItem';

/**
 * Строит дерево пунктов меню из плоского списка
 * @param data Плоский список узлов
 * @param parentId Id родителя
 * @param level Уровень, на котором строят узел
 * @param parentNode Родительский узел
 * @param ancestors Id предков текущего пути, чтобы оборвать цикл
 */
export function generateMenuTree(
    data: IMenuItem[],
    parentId: number | string,
    level: number,
    parentNode: MenuItem | null = null,
    ancestors: ReadonlySet<number | string> = new Set(),
): MenuItem[] {
    const nextAncestors = new Set(ancestors);
    nextAncestors.add(parentId);

    return data.reduce((result: MenuItem[], value) => {
        const nodeId = value.id;
        if (value.parent_id !== parentId || nodeId === undefined || nextAncestors.has(nodeId)) {
            return result;
        }

        const node = new MenuItem(
            Object.assign(
                {
                    level,
                    parentNode,
                },
                value,
            ),
        );
        node.setChildren(generateMenuTree(data, node.id, level + 1, node, nextAncestors));
        result.push(node);
        return result;
    }, []);
}
